import * as actionTypes from "./actionTypes";

const initialState = {
  homeTabData: {
    loading: false
  },
  masterTabData: {
    loading: false
  },
  clockInfoData: {
    loading: false
  },
  triageClockInfoData: {
    loading: false
  },
  clockPrevLogData: {
    loading: false
  },
  clockLogData: {
    loading: false
  },
  triageClockPrevLogData: {
    loading: false
  },
  triageClockLogData: {
    loading: false
  },
  clockDetailInfoData: {
    loading: false
  },
  emailIdData: {
    loading: false
  },
  monthlyViewData: {
    loading: false
  },
  bufferViewData: {
    loading: false
  }
};

const fetchHomeDataStart = (state) => ({
  ...state,
  homeTabData: {
    loading: true
  }
});

const fetchHomeDataSuccess = (state, action) => ({
  ...state,
  homeTabData: {
    loading: false,
    homeData: action.data
  }
});

const fetchHomeDataFail = (state) => ({
  ...state,
  homeTabData: {
    loading: false
  }
});

const fetchMasterDataStart = (state) => ({
  ...state,
  masterTabData: {
    loading: true
  }
});

const fetchMasterDataSuccess = (state, action) => ({
  ...state,
  masterTabData: {
    loading: false,
    masterData: {
      ...action.data
    }
  }
});

const fetchMasterDataFail = (state) => ({
  ...state,
  masterTabData: {
    loading: false
  }
});
const fetchClockInfoFail = (state) => ({
  ...state,
  clockInfoData: {
    loading: false
  }
});
const fetchClockInfoStart = (state) => ({
  ...state,
  clockInfoData: {
    loading: true
  }
});
const fetchClockInfoSuccess = (state, action) => ({
  ...state,
  clockInfoData: {
    loading: false,
    clockInfo: {
      ...action.data
    }
  }
});
const fetchTriageClockInfoFail = (state) => ({
  ...state,
  triageClockInfoData: {
    loading: false
  }
});
const fetchTriageClockInfoStart = (state) => ({
  ...state,
  triageClockInfoData: {
    loading: true
  }
});
const fetchTriageClockInfoSuccess = (state, action) => ({
  ...state,
  triageClockInfoData: {
    loading: false,
    clockInfo: {
      ...action.data
    }
  }
});
const fetchClockLogFail = (state) => ({
  ...state,
  clockLogData: {
    loading: false
  }
});
const fetchClockLogStart = (state) => ({
  ...state,
  clockLogData: {
    loading: true
  }
});
const fetchClockLogSuccess = (state, action) => ({
  ...state,
  clockLogData: {
    loading: false,
    clockLog: {
      ...action.data
    }
  }
});

const fetchTriageClockLogFail = (state) => ({
  ...state,
  triageClockLogData: {
    loading: false
  }
});
const fetchTriageClockLogStart = (state) => ({
  ...state,
  triageClockLogData: {
    loading: true
  }
});
const fetchTriageClockLogSuccess = (state, action) => ({
  ...state,
  triageClockLogData: {
    loading: false,
    clockLog: {
      ...action.data
    }
  }
});

const fetchClockPrevLogFail = (state) => ({
  ...state,
  clockPrevLogData: {
    loading: false
  }
});
const fetchClockPrevLogStart = (state) => ({
  ...state,
  clockPrevLogData: {
    loading: true
  }
});
const fetchClockPrevLogSuccess = (state, action) => ({
  ...state,
  clockPrevLogData: {
    loading: false,
    clockPrevLog: {
      ...action.data
    }
  }
});

const fetchTriageClockPrevLogFail = (state) => ({
  ...state,
  triageClockPrevLogData: {
    loading: false
  }
});
const fetchTriageClockPrevLogStart = (state) => ({
  ...state,
  triageClockPrevLogData: {
    loading: true
  }
});
const fetchTriageClockPrevLogSuccess = (state, action) => ({
  ...state,
  triageClockPrevLogData: {
    loading: false,
    clockPrevLog: {
      ...action.data
    }
  }
});
const fetchClockDetailInfoStart = (state) => ({
  ...state,
  clockDetailInfoData: {
    loading: true
  }
});
const fetchClockDetailInfoSuccess = (state, action) => ({
  ...state,
  clockDetailInfoData: {
    loading: false,
    clockDetailInfo: {
      ...action.data
    }
  }
});
const fetchClockDetailInfoFail = (state) => ({
  ...state,
  clockDetailInfoData: {
    loading: false
  }
});
const fetchMonthlyViewStart = (state) => ({
  ...state,
  monthlyViewData: {
    loading: true
  }
});
const fetchMonthlyViewSuccess = (state, action) => ({
  ...state,
  monthlyViewData: {
    loading: false,
    monthlyView: {
      ...action.data
    }
  }
});
const fetchMonthlyViewFail = (state) => ({
  ...state,
  monthlyViewData: {
    loading: false
  }
});
const fetchBufferViewStart = (state) => ({
  ...state,
  bufferViewData: {
    loading: true
  }
});
const fetchBufferViewSuccess = (state, action) => ({
  ...state,
  bufferViewData: {
    loading: false,
    bufferView: {
      ...action.data
    }
  }
});
const fetchBufferViewFail = (state) => ({
  ...state,
  bufferViewData: {
    loading: false
  }
});
const fetchEmailIdListStart = (state) => ({
  ...state,
  emailIdData: {
    loading: true
  }
});

const fetchEmailIdListSuccess = (state, action) => ({
  ...state,
  emailIdData: {
    loading: false,
    emailIdList: action.data
  }
});
const fetchEmailIdListFail = (state) => ({
  ...state,
  emailIdData: {
    loading: false,
    emailIdList: []
  }
});
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EMAILD_LIST_START:
      return fetchEmailIdListStart(state);
    case actionTypes.FETCH_EMAILD_LIST_SUCCESS:
      return fetchEmailIdListSuccess(state, action);
    case actionTypes.FETCH_EMAILD_LIST_FAILURE:
      return fetchEmailIdListFail(state);
    case actionTypes.FETCH_HOME_DATA_START:
      return fetchHomeDataStart(state);
    case actionTypes.FETCH_HOME_DATA_SUCCESS:
      return fetchHomeDataSuccess(state, action);
    case actionTypes.FETCH_HOME_DATA_FAIL:
      return fetchHomeDataFail(state);
    case actionTypes.FETCH_MASTER_DATA_START:
      return fetchMasterDataStart(state);
    case actionTypes.FETCH_MASTER_DATA_SUCCESS:
      return fetchMasterDataSuccess(state, action);
    case actionTypes.FETCH_MASTER_DATA_FAIL:
      return fetchMasterDataFail(state);
    case actionTypes.FETCH_CLOCK_INFO_START:
      return fetchClockInfoStart(state);
    case actionTypes.FETCH_CLOCK_INFO_SUCCESS:
      return fetchClockInfoSuccess(state, action);
    case actionTypes.FETCH_CLOCK_INFO_FAIL:
      return fetchClockInfoFail(state);
    case actionTypes.FETCH_CLOCK_LOG_START:
      return fetchClockLogStart(state);
    case actionTypes.FETCH_CLOCK_LOG_SUCCESS:
      return fetchClockLogSuccess(state, action);
    case actionTypes.FETCH_CLOCK_LOG_FAIL:
      return fetchClockLogFail(state);
    case actionTypes.FETCH_CLOCK_PREV_LOG_START:
      return fetchClockPrevLogStart(state);
    case actionTypes.FETCH_CLOCK_PREV_LOG_SUCCESS:
      return fetchClockPrevLogSuccess(state, action);
    case actionTypes.FETCH_CLOCK_PREV_LOG_FAIL:
      return fetchClockPrevLogFail(state);
    case actionTypes.FETCH_CLOCK_DETAIL_INFO_START:
      return fetchClockDetailInfoStart(state);
    case actionTypes.FETCH_CLOCK_DETAIL_INFO_SUCCESS:
      return fetchClockDetailInfoSuccess(state, action);
    case actionTypes.FETCH_CLOCK_DETAIL_INFO_FAIL:
      return fetchClockDetailInfoFail(state);
    case actionTypes.FETCH_REPORTS_MONTHLY_START:
      return fetchMonthlyViewStart(state);
    case actionTypes.FETCH_REPORTS_MONTHLY_SUCCESS:
      return fetchMonthlyViewSuccess(state, action);
    case actionTypes.FETCH_REPORTS_MONTHLY_FAIL:
      return fetchMonthlyViewFail(state);
    case actionTypes.FETCH_REPORTS_BUFFER_START:
      return fetchBufferViewStart(state);
    case actionTypes.FETCH_REPORTS_BUFFER_SUCCESS:
      return fetchBufferViewSuccess(state, action);
    case actionTypes.FETCH_REPORTS_BUFFER_FAIL:
      return fetchBufferViewFail(state);
    case actionTypes.FETCH_TRIAGE_CLOCK_INFO_START:
      return fetchTriageClockInfoStart(state);
    case actionTypes.FETCH_TRIAGE_CLOCK_INFO_SUCCESS:
      return fetchTriageClockInfoSuccess(state, action);
    case actionTypes.FETCH_TRIAGE_CLOCK_INFO_FAIL:
      return fetchTriageClockInfoFail(state);
    case actionTypes.FETCH_TRIAGE_CLOCK_LOG_START:
      return fetchTriageClockLogStart(state);
    case actionTypes.FETCH_TRIAGE_CLOCK_LOG_SUCCESS:
      return fetchTriageClockLogSuccess(state, action);
    case actionTypes.FETCH_TRIAGE_CLOCK_LOG_FAIL:
      return fetchTriageClockLogFail(state);
    case actionTypes.FETCH_TRIAGE_CLOCK_PREV_LOG_START:
      return fetchTriageClockPrevLogStart(state);
    case actionTypes.FETCH_TRIAGE_CLOCK_PREV_LOG_SUCCESS:
      return fetchTriageClockPrevLogSuccess(state, action);
    case actionTypes.FETCH_TRIAGE_CLOCK_PREV_LOG_FAIL:
      return fetchTriageClockPrevLogFail(state);
    default:
      return state;
  }
};

export default reducer;
